import React, {Component} from 'react';
import {Divider, Dimmer, Loader, Grid, Segment, GridRow, Input} from 'semantic-ui-react'
import {changeFontColor} from "../../shared/helpers/styles";

export default class BudgetItem extends Component {

  render() {

    const number_pattern = '\\d[0-9]*(\\.)?(\\d{1,2})?';
    const PageLoader = () => (
      <Dimmer active={this.props.showLoader} inverted>
        <Loader size='medium'>Loading Budget Summary ...</Loader>
      </Dimmer>
    );

    return (

      <div>
        <PageLoader/>
        <Grid stackable>
          <Grid.Column width={8}>
            <Segment>
              <Grid>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}><b>Monthly Income</b></Grid.Column>
                  <Grid.Column width={4}><b>Projected</b></Grid.Column>
                  <Grid.Column width={4}><b>Actual</b></Grid.Column>
                  <Grid.Column width={3}><b>Difference</b></Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Take Home Pay</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_take_home_pay'
                           value={this.props.projected_take_home_pay} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_take_home_pay)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='take_home_pay'
                           value={this.props.take_home_pay} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_take_home_pay'
                           className={changeFontColor(this.props.diff_take_home_pay)}>$ {this.props.diff_take_home_pay}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Other Income</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_other_income'
                           value={this.props.projected_other_income} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_other_income)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='other_income'
                           value={this.props.other_income} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_other_income'
                           className={changeFontColor(this.props.diff_other_income)}>$ {this.props.diff_other_income}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Alimony</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_alimony'
                           value={this.props.projected_alimony} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_alimony)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='alimony'
                           value={this.props.alimony} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_alimony'
                           className={changeFontColor(this.props.diff_alimony)}>$ {this.props.diff_alimony}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Child Support</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_child_support_gain'
                           value={this.props.projected_child_support_gain} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_child_support_gain)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='child_support_gain'
                           value={this.props.child_support_gain} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_child_support_gain'
                           className={changeFontColor(this.props.diff_child_support_gain)}>$ {this.props.diff_child_support_gain}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Social Security</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_social_security'
                           value={this.props.projected_social_security} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_social_security)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='social_security'
                           value={this.props.social_security} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_social_security'
                           className={changeFontColor(this.props.diff_social_security)}>$ {this.props.diff_social_security}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Retirement Income</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_retirement_income'
                           value={this.props.projected_retirement_income} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_retirement_income)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='retirement_income'
                           value={this.props.retirement_income} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_retirement_income'
                           className={changeFontColor(this.props.diff_retirement_income)}>$ {this.props.diff_retirement_income}</label>
                  </Grid.Column>
                </GridRow>
              </Grid>
            </Segment>
          </Grid.Column>

          <Grid.Column width={8}>
            <Segment>
              <Grid>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}><b>Monthly Expenses</b></Grid.Column>
                  <Grid.Column width={4}><b>Projected</b></Grid.Column>
                  <Grid.Column width={4}><b>Actual</b></Grid.Column>
                  <Grid.Column width={3}><b>Difference</b></Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Mortgage / Rent</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_rent'
                           value={this.props.projected_rent} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_rent)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left' name='rent'
                           value={this.props.rent} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_rent'
                           className={changeFontColor(this.props.diff_rent)}>$ {this.props.diff_rent}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Utilities</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_utilities'
                           value={this.props.projected_utilities} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_utilities)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='utilities'
                           value={this.props.utilities} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_utilities'
                           className={changeFontColor(this.props.diff_utilities)}>$ {this.props.diff_utilities}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Transportation</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_transportation'
                           value={this.props.projected_transportation} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_transportation)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='transportation'
                           value={this.props.transportation} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_transportation'
                           className={changeFontColor(this.props.diff_transportation)}>$ {this.props.diff_transportation}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Insurance Premiums</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_insurance_premiums'
                           value={this.props.projected_insurance_premiums} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_insurance_premiums)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='insurance_premiums'
                           value={this.props.insurance_premiums} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_insurance_premiums'
                           className={changeFontColor(this.props.diff_insurance_premiums)}>$ {this.props.diff_insurance_premiums}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Food</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_food'
                           value={this.props.projected_food} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_food)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left' name='food'
                           value={this.props.food} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_food'
                           className={changeFontColor(this.props.diff_food)}>$ {this.props.diff_food}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>
                    Telephone</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_telephone'
                           value={this.props.projected_telephone} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_telephone)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='telephone'
                           value={this.props.telephone} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_telephone'
                           className={changeFontColor(this.props.diff_telephone)}>$ {this.props.diff_telephone}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Medical Bills</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_medical_bills'
                           value={this.props.projected_medical_bills} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_medical_bills)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='medical_bills'
                           value={this.props.medical_bills} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_medical_bills'
                           className={changeFontColor(this.props.diff_medical_bills)}>$ {this.props.diff_medical_bills}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Back Taxes</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_back_taxes'
                           value={this.props.projected_back_taxes} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_back_taxes)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='back_taxes'
                           value={this.props.back_taxes} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_back_taxes'
                           className={changeFontColor(this.props.diff_back_taxes)}>$ {this.props.diff_back_taxes}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}> Student Loans</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_student_loans'
                           value={this.props.projected_student_loans} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_student_loans)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='student_loans'
                           value={this.props.student_loans} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_student_loans'
                           className={changeFontColor(this.props.diff_student_loans)}>$ {this.props.diff_student_loans}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Alimony & Child Support</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_child_support_loss'
                           value={this.props.projected_child_support_loss} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_child_support_loss)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='child_support_loss'
                           value={this.props.child_support_loss} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_child_support_loss'
                           className={changeFontColor(this.props.diff_child_support_loss)}>$ {this.props.diff_child_support_loss}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Child Care</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_child_care'
                           value={this.props.projected_child_care} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_child_care)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='child_care'
                           value={this.props.child_care} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_child_care'
                           className={changeFontColor(this.props.diff_child_care)}>$ {this.props.diff_child_care}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Misc / Other</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_other_expenses'
                           value={this.props.projected_other_expenses} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_other_expenses)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='other_expenses'
                           value={this.props.other_expenses} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_other_expenses'
                           className={changeFontColor(this.props.diff_other_expenses)}>$ {this.props.diff_other_expenses}</label>
                  </Grid.Column>
                </GridRow>

                <Divider/>

                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>2nd Mortgage / Rent</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_rent_2'
                           value={this.props.projected_rent_2} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_rent_2)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='rent_2'
                           value={this.props.rent_2} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_rent_2'
                           className={changeFontColor(this.props.diff_rent_2)}>$ {this.props.diff_rent_2}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Auto Other</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_auto_other'
                           value={this.props.projected_auto_other} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_auto_other)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='auto_other'
                           value={this.props.auto_other} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_auto_other'
                           className={changeFontColor(this.props.diff_auto_other)}>$ {this.props.diff_auto_other}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Cable TV</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_tv'
                           value={this.props.projected_tv} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_tv)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left' name='tv'
                           value={this.props.tv} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_tv' className={changeFontColor(this.props.diff_tv)}>$ {this.props.diff_tv}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Charity / Donations</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_charity'
                           value={this.props.projected_charity} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_charity)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='charity'
                           value={this.props.charity} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_charity'
                           className={changeFontColor(this.props.diff_charity)}>$ {this.props.diff_charity}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Clothing</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_clothing'
                           value={this.props.projected_clothing} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_clothing)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='clothing'
                           value={this.props.clothing} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_clothing'
                           className={changeFontColor(this.props.diff_clothing)}>$ {this.props.diff_clothing}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Education</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_education'
                           value={this.props.projected_education} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_education)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='education'
                           value={this.props.education} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_education'
                           className={changeFontColor(this.props.diff_education)}>$ {this.props.diff_education}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Entertainment</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_entertainment'
                           value={this.props.projected_entertainment} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_entertainment)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='entertainment'
                           value={this.props.entertainment} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_entertainment'
                           className={changeFontColor(this.props.diff_entertainment)}>$ {this.props.diff_entertainment}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Gym / Health</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_health'
                           value={this.props.projected_health} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_health)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='health'
                           value={this.props.health} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_health'
                           className={changeFontColor(this.props.diff_health)}>$ {this.props.diff_health}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Home Insurance</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_home_insurance'
                           value={this.props.projected_home_insurance} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_home_insurance)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='home_insurance'
                           value={this.props.home_insurance} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_home_insurance'
                           className={changeFontColor(this.props.diff_home_insurance)}>$ {this.props.diff_home_insurance}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Household Items</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_household_items'
                           value={this.props.projected_household_items} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_household_items)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='household_items'
                           value={this.props.household_items} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_household_items'
                           className={changeFontColor(this.props.diff_household_items)}>$ {this.props.diff_household_items}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Life Insurance</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_life_insurance'
                           value={this.props.projected_life_insurance} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_life_insurance)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='life_insurance'
                           value={this.props.life_insurance} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_life_insurance'
                           className={changeFontColor(this.props.diff_life_insurance)}>$ {this.props.diff_life_insurance}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Laundry / Dry Cleaning</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_laundry'
                           value={this.props.projected_laundry} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_laundry)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='laundry'
                           value={this.props.laundry} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_laundry'
                           className={changeFontColor(this.props.diff_laundry)}>$ {this.props.diff_laundry}</label>
                  </Grid.Column>
                </GridRow>
                <GridRow className='grid-padding'>
                  <Grid.Column width={5}>Medical Care</Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='projected_medical_care'
                           value={this.props.projected_medical_care} onChange={this.props.handleUserInput}
                           className={`input-budget ${this.props.errorClass(this.props.projected_medical_care)}`}
                           readOnly={this.props.projected_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input type='text' pattern={number_pattern} fluid icon='dollar sign' iconPosition='left'
                           name='medical_care'
                           value={this.props.medical_care} onChange={this.props.updateStateProp}
                           className='input-budget' readOnly={this.props.actual_readonly}/>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <label name='diff_medical_care'
                           className={changeFontColor(this.props.diff_medical_care)}>$ {this.props.diff_medical_care}</label>
                  </Grid.Column>
                </GridRow>
              </Grid>
            </Segment>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/BudgetItemMonthly/index.js